import { Controller } from "@hotwired/stimulus"

// Disables the submit button(s) until at least one checkbox target is checked.
// Used by the Data Sources panel's "Link Selected" form so an empty selection
// can't be submitted. Without JS the button stays enabled and the server's
// "select at least one" redirect handles it.
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.refresh()
  }

  refresh() {
    const anyChecked = this.checkboxTargets.some((checkbox) => checkbox.checked)
    this.submitTargets.forEach((button) => (button.disabled = !anyChecked))
  }
}
